function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 29C22.732 29 29 22.732 29 15C29 7.26801 22.732 1 15 1C7.26801 1 1 7.26801 1 15C1 22.732 7.26801 29 15 29Z",
  stroke: "#8A909F",
  strokeWidth: 1.8
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.3918 14.3799C21.6148 14.401 21.822 14.5045 21.9727 14.6702C22.1235 14.8359 22.207 15.0519 22.207 15.2759C22.207 15.4999 22.1235 15.7159 21.9727 15.8816C21.822 16.0473 21.6148 16.1508 21.3918 16.1719H10.1848C9.96176 16.1508 9.75462 16.0473 9.60386 15.8816C9.4531 15.7159 9.36955 15.4999 9.36955 15.2759C9.36955 15.0519 9.4531 14.8359 9.60386 14.6702C9.75462 14.5045 9.96176 14.401 10.1848 14.3799L21.3918 14.3799Z",
  fill: "#8A909F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.25914 14.6418L12.6941 10.2058C12.8668 10.0633 13.0863 9.99029 13.3099 10.001C13.5335 10.0116 13.7451 10.1053 13.9034 10.2635C14.0617 10.4218 14.1553 10.6334 14.166 10.857C14.1766 11.0806 14.1036 11.3002 13.9611 11.4728L10.1611 15.2728L13.9611 19.0728C14.1036 19.2454 14.1766 19.465 14.166 19.6886C14.1553 19.9122 14.0617 20.1238 13.9034 20.2821C13.7451 20.4403 13.5335 20.534 13.3099 20.5446C13.0863 20.5553 12.8668 20.4823 12.6941 20.3398L8.25914 15.9058C8.09303 15.7374 7.9999 15.5103 7.9999 15.2738C7.9999 15.0372 8.09303 14.8102 8.25914 14.6418Z",
  fill: "#8A909F"
});

var SvgLogoutIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoutIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logout-icon.26bd5a81.svg";
export { ForwardRef as ReactComponent };